











import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EditorSectionMini extends Vue {
  @Prop() private title!: string;
}
